module.exports = __webpack_public_path__ + "assets/gcgv-facility.jpg?9a0f305e9a30525cf51e986556c0d91d";